import styled from "styled-components";
import { colors } from "../../styles/figmaColors";
import { Spacer } from "./Spacer";
import { typographies } from "../../styles/figmaTypographies";
import Car from "../assets/CarGrey.png";
import { useTranslation } from "react-i18next";
import { TextCapitalized } from "./text/TextCapitalized";
import { Badge } from "./Tag/Badge";
import "../../../i18n/i18n";

export interface TripsAndPlanningsVehicleCardProps {
  registrationNumber: string | null;
  totalDistance: number;
  type: "TRIP" | "PLANNING";
  driverCity?: string | null;
}

export const TripsAndPlanningsVehicleCard = (
  props: TripsAndPlanningsVehicleCardProps,
) => {
  const { t } = useTranslation();

  const { registrationNumber, totalDistance, driverCity } = props;

  return (
    <StyledVehicleCard>
      <Spacer x={1.5} />
      <StyledColumn>
        <Spacer y={1} />
        <StyledRegistrationNumber>
          <TextCapitalized>
            {t(`trips.details.vehicleCard.${props.type}`)}
          </TextCapitalized>
          <Spacer x={0.5} />
          {registrationNumber && (
            <>
              {registrationNumber}
              <Spacer x={0.5} />
              <StyledCenter>
                <StyledImg src={Car} alt="Car" />
              </StyledCenter>
            </>
          )}
        </StyledRegistrationNumber>
        <Spacer y={0.5} />
        <StyledTitle>
          <TextCapitalized>
            {t("trips.details.vehicleCard.distance")} :
          </TextCapitalized>
          <Spacer x={0.5} />
          <Badge
            text={
              <StyledBodyText>
                {totalDistance.toFixed(2) + " km"}
              </StyledBodyText>
            }
            backgroundColor={
              colors["colors/system/informative/informative_veryLight"]
            }
            textColor={colors["colors/text/darkGrey"]}
          />
        </StyledTitle>
        <Spacer y={0.5} />
        {driverCity && (
          <StyledTitle>
            <TextCapitalized>
              {t("trips.details.vehicleCard.driverCity")} :
            </TextCapitalized>
            <Spacer x={0.5} />
            <StyledDriverCity>{driverCity}</StyledDriverCity>
          </StyledTitle>
        )}
        <Spacer y={1} />
      </StyledColumn>
      <Spacer x={1.5} />
    </StyledVehicleCard>
  );
};

const StyledVehicleCard = styled.div`
  display: flex;
  background-color: ${colors["colors/button/secondary/hover"]};
  border-radius: 0.5rem;
  max-width: 20rem;
`;

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledImg = styled.img`
  width: 2rem;
`;

const StyledCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledRegistrationNumber = styled.div`
  display: flex;
  ${typographies["Body/L"]};
  white-space: nowrap;
`;

const StyledTitle = styled.div`
  display: flex;
  ${typographies["Body/S"]};
  align-items: center;
`;

const StyledBodyText = styled.div`
  ${typographies["Body/XXS"]};
`;

const StyledDriverCity = styled.div`
  max-width: 10rem;
  white-space: wrap;
`;
